import { Outlet, useMatches } from "@tanstack/react-router";
import type React from "react";
import { useState } from "react";
import { Navbar } from "@/components/navigation/Navbar";
import { Sidebar } from "@/components/navigation/Sidebar";
import { PAGE_PATHS } from "@/config/urls";
import { cn } from "@/lib/utils";

export const Layout: React.FC = () => {
  // Get current route matches
  const matches = useMatches();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  // Check if current route is the callback page
  const isFullscreenPage = matches.some(
    (match) => match.routeId === PAGE_PATHS.CALLBACK,
  );

  // If it's the callback page or workspace screen, only render the Outlet without navbar and sidebar
  if (isFullscreenPage) {
    return (
      <div className="h-screen bg-white">
        <Outlet />
      </div>
    );
  }

  // Otherwise render the full layout with navbar and sidebar
  return (
    <div className="flex h-screen flex-col overflow-visible bg-white">
      <Navbar />
      <div className="mt-[60px] flex h-[calc(100vh-60px)] min-h-0">
        <aside
          className={cn(
            "shrink-0 overflow-y-auto overflow-x-hidden transition-all duration-300",
            isSidebarCollapsed ? "w-[64px]" : "w-[307px]",
          )}
        >
          <Sidebar
            isCollapsed={isSidebarCollapsed}
            onToggle={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
          />
        </aside>
        <main className="min-w-0 flex-1 overflow-hidden">
          <div className="flex h-full min-h-0 flex-col bg-white">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};
